angular.module('cvsApp').service('symptomTrackerEligibilityService', ['networkService', 'xdrService', 'configManager', 'symptomTrackerEligibilityModal', 'cvsAppData', function (NS, XS, CM, STEM, CAD) {

	function symptomTrackerEligibilityService() {
		this.symptomTrackerEligibility = function (indicationNames, callBackSuccess) {

			var tokenId, tokenType;

			try {
				tokenId = CAD.getTokenId() ? CAD.getTokenId() : cvsUtility.queryMap.tokenId;
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : 'Login';
			}
			catch (ex) {
				tokenId = cvsUtility.queryMap.tokenId;
				tokenType = 'Login';
			}

			var url = CM.getAGPAPIUrl('AGP_FIND_SYMPTOM_TRACKER_ELG');
			var url = CVS.Config.serviceHost[cvsUtility.queryMap.env]+"SPLAGPv1/oncologyservice/findSymptomTrackerEligibility/v1";
            if(cvsUtility.queryMap.env === 'local'){
				url = CVS.Config.serviceHost[cvsUtility.queryMap.env] +"specialty/oncologyservice/findSymptomTrackerEligibility/v1";
			}
			if (url === "URL_ERROR") {

			} else {
				var request = {
					url: url,
					header: {
						"Content-Type": "application/json",
						"Accept": "application/json"
					},
					data: getRequestBody(indicationNames, tokenId, tokenType),
					onSuccess: callBackSuccess
				}
				cvsUtility.commonServiceCode(url, "findSymptomTrackerEligibility", STEM, request, callBackSuccess, NS);
			}

		}

		var getRequestBody = function (indicationNames, tokenId, tokenType) {
			var apikey = CAD.hasOwnProperty('getApiKey') && CAD.getApiKey() ? CAD.getApiKey() : cvsUtility.queryMap.apikey;
			var reqObj = {
				"findSymptomTrackerEligibilityRequest": {
					"header": {
						"serviceContext": {
							"appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
							"lineOfBusiness": "Specialty",
							"channelName": cvsUtility.queryMap.channel,
							"responseFormat": "JSON",
							"type": "SPLSBMS",
							"bkAppName": "conditionManagement",
							"tokenID": tokenId,
							"tokenType": CM.getAGPTokenType(tokenType)

						},
						"securityContext": {
							"apiKey": apikey,
							"securityType": "apiKey"
						}
					},
					"details": {
						"gpiCode": null,
						"indicationName": indicationNames
					}
				}
			};

			return reqObj;
		}

	}

	return new symptomTrackerEligibilityService();
}]);
